export type IntegrationConfigResponse = {
  venue_id: string;
  enabled_integration_types: IntegrationType[];
  integrator_id: string | null;
};

export type IntegrationConfig = {
  venueId: string;
  integratorId: string | null;
  enabledIntegrationTypes: {
    [key in IntegrationType]: boolean;
  };
};

export enum IntegrationType {
  ORDER_API = 'ORDER_API',
  MC_DONALD_ISR = 'MC_DONALD_ISR',
  SKYLARK = 'SKYLARK',
  SUBWAY = 'SUBWAY',
  MC_DONALD_GLOBAL_ORDER = 'MC_DONALD_GLOBAL_ORDER',
  MC_DONALD_GLOBAL_MENU = 'MC_DONALD_GLOBAL_MENU',
  MENU_API = 'MENU_API',
  ITEM_API = 'ITEM_API',
  INVENTORY_API = 'INVENTORY_API',
  SFTP_CONFIG = 'SFTP_CONFIG',
  LISTINGS = 'LISTINGS',
  SSIO = 'SSIO',
}
